export default "__VITE_ASSET__DRpHKbQT__"